import * as React from 'react';
import { AutocompleteResultsContainer } from '../../containers/AutocompleteResultsContainer';
import { HangarsStateContainer } from '../../containers/HangarsStateContainer';
import { RampsStateContainer } from '../../containers/RampsStateContainer';
import { TowingEquipmentContainer } from '../../containers/TowingEquipmentContainer';
import { OpsView } from './OpsView';

/**
 * Ops screen - unified queue + multi-hangar view
 * Bridges CSR workflow (receiving requests) with Line Manager workflow (placing aircraft)
 *
 * Note: MultiHangarStateContainer is created inside OpsView with the selected hangar IDs,
 * not here, because we need to know which hangars are selected before initializing it.
 */
export const Ops: React.FC = () => {
  return (
    <AutocompleteResultsContainer>
      <RampsStateContainer isReference={false}>
        <HangarsStateContainer isReference={false}>
          <TowingEquipmentContainer>
            <OpsView />
          </TowingEquipmentContainer>
        </HangarsStateContainer>
      </RampsStateContainer>
    </AutocompleteResultsContainer>
  );
};
